
export class CalificacionConductor {
    IdCalificacion: number;
    IdCliente: number;
    IdServicio: number
    IdConductor: string;
    Estrellas: number
    Comentario: string;
    Calificado: boolean;

    constructor() {
        this.Comentario = '';
        this.Calificado=false
    }
}